import window from 'global/window';

export const getPortalNameFromUrl = (url?: string) => {
	const _url = new URL(url ?? (window.location.href as string));
	const paths = _url.pathname.split('/');
	return paths[paths.length - 2] || 'portal';
};

export default getPortalNameFromUrl;
